import { Injectable } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { Store } from '@ngrx/store';
import { actions } from '@twaice-fe/frontend/shared/store';
import { Hub } from 'aws-amplify';

const { authActions } = actions;

@Injectable({
  providedIn: 'root',
})
export class AmplifyInternalService {
  constructor(private store: Store) {
    Hub.listen('auth', () => {
      this.emitUser();
    });

    // emit user initially to determine if a session exists
    this.emitUser();
  }

  async updateUserAttribute(attributes: Record<string, string>): Promise<string> {
    const user = await Auth.currentAuthenticatedUser();
    return Auth.updateUserAttributes(user, attributes);
  }

  private async emitUser(): Promise<void> {
    try {
      const user = await Auth.currentAuthenticatedUser();

      this.store.dispatch(authActions.userChanged({ user: JSON.parse(JSON.stringify(user)) }));
    } catch (error) {
      this.store.dispatch(authActions.userChanged({ user: null }));
    }
  }
}
